import { useState } from 'react'
import { ArrowRight, FilePlus2 } from 'lucide-react'
import { CARD_COLORS, CARD_COLUMNS } from '../data'
import { charCount, summaryFromContent } from '../lib/utils'
import { ModalShell } from './Shared'

export default function NewCardModal({ defaultColumn = 'inspiration', acts, defaultAct, onClose, onCreate }) {
  const [title, setTitle] = useState('')
  const [content, setContent] = useState('')
  const [column, setColumn] = useState(defaultColumn)
  const [act, setAct] = useState(defaultAct || acts[0] || '第一幕 · 未命名')
  const [color, setColor] = useState('sand')
  const [error, setError] = useState('')

  function submit(event) {
    event.preventDefault()
    if (!title.trim()) { setError('先给这张卡片一个名字。'); return }
    const text = content.trim()
    onCreate({
      title: title.trim(),
      content: text,
      summary: summaryFromContent(text, '一张刚刚开始的卡片。'),
      tags: [],
      act,
      column,
      color,
    })
  }

  return (
    <ModalShell onClose={onClose} width="710px" className="new-card-modal">
      <form onSubmit={submit}>
        <div className="modal-topline"><span><FilePlus2 size={14} /> NEW CARD</span><em>先放进一张卡片，再慢慢想</em></div>
        <div className="new-card-head">
          <h2>新建一张卡片。</h2>
          <p>可以只有一个标题。空白也是结构的一部分。</p>
        </div>

        <div className="new-card-form">
          <label>
            <span className="field-label"><span>标题</span><em>必填</em></span>
            <input
              className={'text-input text-input--title ' + (error ? 'has-error' : '')}
              value={title}
              onChange={(event) => { setTitle(event.target.value); setError('') }}
              placeholder="例如：母亲的口琴"
              autoFocus
            />
          </label>
          <label>
            <span className="field-label"><span>第一段内容</span><em>{charCount(content)} 字</em></span>
            <textarea
              className="text-area"
              value={content}
              onChange={(event) => setContent(event.target.value)}
              placeholder="可以先写一句动作、一段对话，或一个还没有解释的画面……"
              rows={5}
            />
          </label>
          <div className="new-card-row">
            <div>
              <span className="field-label"><span>所属幕</span></span>
              <select className="select-input" value={act} onChange={(event) => setAct(event.target.value)}>
                {acts.map((item) => <option key={item} value={item}>{item}</option>)}
                <option value="未分幕">未分幕</option>
              </select>
            </div>
            <div>
              <span className="field-label"><span>放上哪张桌</span></span>
              <div className="stage-select">
                {CARD_COLUMNS.map((item) => (
                  <button type="button" key={item.id} className={column === item.id ? 'is-active' : ''} onClick={() => setColumn(item.id)}>
                    <i style={{ background: item.color }} />{item.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="new-card-colors">
            <span className="field-label"><span>纸张</span></span>
            {Object.entries(CARD_COLORS).map(([key, swatch]) => (
              <button
                type="button"
                key={key}
                className={'color-swatch ' + (color === key ? 'is-active' : '')}
                style={{ background: swatch }}
                onClick={() => setColor(key)}
                aria-label={'纸张颜色 ' + key}
              >{color === key ? '✓' : ''}</button>
            ))}
          </div>
        </div>

        {error ? <div className="form-error">{error}</div> : null}
        <div className="modal-footer">
          <span className="modal-footer__hint">创建后可以拖动到其他阶段，或拉到看板上连线。</span>
          <div>
            <button type="button" className="btn btn--ghost" onClick={onClose}>取消</button>
            <button type="submit" className="btn btn--ink">创建卡片 <ArrowRight size={15} /></button>
          </div>
        </div>
      </form>
    </ModalShell>
  )
}
